import * as React from "react";
import {useEffect, useState} from "react";
import {
    currentPlan,
    currentProductPageTab,
    hasClientResearchEnabled,
    hasResearchAccess,
    isEditingPlanPortfolio,
    oddIqEnabled,
    planCountryName,
    portfolioProductSummariesSelector,
    userType
} from "../../../mainReducerMapSelectors";
import {getSuccessData, REQUEST_STATES, RequestState} from "../common/commonStates";
import {AnyAction, bindActionCreators, Dispatch} from "redux";
import productActions, {
    addProductToPlanPortfolio,
    clearTickerData,
    requestMostRecentInReports,
    requestProduct,
    setActiveProduct,
    setCurrentProductTab
} from "./productActions";
import {connect, useDispatch} from "react-redux";
import {FormattedMessage, useIntl} from "react-intl";
import {multipleApiRequesterWrapper} from "../common/MultipleApiRequesterWrapper";
import {shareClassRequestPair} from "../common/RequesterPairs";
import {ErrorComponent} from "../base/Error.component";
import {LoadingSpinner} from "../icons/LoadingSpinner.component";
import {Product} from "../../model/product/Product.model";
import {ApiError} from "../../model/ApiError.model";
import {IPlanInfo} from "../../model/ClientsAndPlans.model";
import {UserTypeEnum} from "../../model/UserInfo.model";
import {Map as ImmutableMap, Map} from "immutable";
import {ProductSummary} from "../../model/product/ProductSummary";
import {IOddResponse, IOddSectionsQuestions} from "../../api/OddIqApi";
import {InvestmentDueDiligence} from "./due-diligence/InvestmentDueDiligence";
import ProductFlashReports from "./flash-reports/ProductFlashReports";
import {NOT_RATED, NR_RATING} from "../../utils/ratingConstants";
import {OperationalDueDiligence} from "./operational-due-diligence/OperationalDueDiligence";
import {getQueryStringParam} from "../../utils/browserUtil";
import {RaisedButton} from "../common/RaisedButton";
import {defaultButtonStyle} from "../common/buttonStyles";
import {
    oddProductDateRespondedSelector,
    oddResponsesByBackstopSelector,
    operationalDueDiligenceSectionsQuestionsSelector
} from "../odd-iq/OddIqRequesterPairs";
import {
    requestOddProductDateRespondedForCurrentPlan,
    requestOddResponsesByBackstopForCurrentPlan,
    requestOddSectionsAndQuestions
} from "../odd-iq/OddIqActions";
import {IApplicationRootState} from "../../../applicationState";
import {InformInvestmentDueDiligence} from "../inform/InformInvestmentDueDiligence";
import {ProductRatingType} from "../../model/product/ProductRatingType";
import {InFormReportingApi} from "../../api/InFormReportingApi";
import {IInformProduct, IInformProps} from "../../model/inform/InformProduct";
import {IInformPerformance} from "../../model/inform/InformPerformance";
import {ProductPerformanceAnalytics} from "./performance-analytics/ProductPerformanceAnalytics";
import {getPortfolioProductSummaries} from "./AllProductsActions";
import {ProductResearcher} from "./ProductResearcher";
import {EMPOWER_RESULTS_PLAN} from "../../utils/sessionUtil";
import {Country} from "../admin/AdminAllClients";
import {useNavigate, useNavigationType} from "react-router-dom";
import {useParams} from "react-router";
import {navigateTo, notPopNavigation} from "../../../navigateTo";
import {AnyThunkDispatch} from "../../../commonTypes";
import {UserBehaviorTrackerApi} from "../../api/UserBehaviorTrackerApi";
import {getBrowserLocationPath} from "../../api/BrowserWrapper";

export enum ProductPageTab {
    IDD = "INVESTMENT DUE DILIGENCE",
    PERFORMANCE_ANALYTICS = "PERFORMANCE ANALYTICS",
    ODD = "OPERATIONAL DUE DILIGENCE",
    FLASH_REPORTS = "FLASH REPORTS",
}

export interface IProductPropsFromActions {
    actions: {
        setActiveProduct: typeof setActiveProduct;
        requestProduct: typeof requestProduct;
        addProductToPlanPortfolio: typeof addProductToPlanPortfolio;
        clearTickerData: typeof clearTickerData;
        requestMostRecentInReports: typeof requestMostRecentInReports;
    };
}

export interface IProductPagePropsFromStore {
    product?: Product;
    productLoading?: boolean;
    productError?: ApiError;
    editingPlanPortfolio: boolean;
    currentPlan: IPlanInfo;
    userType: UserTypeEnum;
    planCountryName: string;
    portfolioProductSummaries: Map<number, ProductSummary> | null;
    portfolioProductSummariesState: RequestState<Map<number, ProductSummary>>;
    oddProductQuestionResponse: RequestState<IOddResponse[]>;
    oddIqEnabled: boolean;
    hasClientResearchEnabled: boolean;
    hasResearchAccess: boolean;
    oddSectionsQuestions: RequestState<IOddSectionsQuestions>;
    oddProductDateResponded: RequestState<ImmutableMap<number, string>>;
    currentTab?: ProductPageTab;
}

export type ProductPageProps =
    IProductPropsFromActions &
    IProductPagePropsFromStore;

export const ProductPage: React.FunctionComponent<ProductPageProps> = (props) => {
    const [informProps, setInformProps] = useState<IInformProps | undefined>(undefined);
    const [renderErrorComponent, setRenderErrorComponent] = useState<boolean>(false);
    const [informLoading, setInformLoading] = useState<boolean>(true);

    const intl = useIntl();

    const queryStringTab = getQueryStringParam("tab");
    const dispatch: AnyThunkDispatch = useDispatch();
    const navigate = useNavigate();

    const {backstopIdParam} = useParams();
    const productBackstopId = Number.parseInt(backstopIdParam!, 10);

    const {product} = props;

    const isProductAccessible = () => {
        return props.portfolioProductSummaries?.has(productBackstopId)
        || props.editingPlanPortfolio;
    };


    const requestProductDetails = () => {
        if (isProductAccessible()) {
            props.actions.requestProduct(productBackstopId);
            props.actions.clearTickerData();
            props.actions.requestMostRecentInReports(productBackstopId);
        }
    };

    const requestOddData = () =>{
        if(props.oddIqEnabled) {
            if (props.oddProductQuestionResponse.kind === REQUEST_STATES.NOT_REQUESTED)
                dispatch(requestOddResponsesByBackstopForCurrentPlan);

            if (props.oddSectionsQuestions.kind === REQUEST_STATES.NOT_REQUESTED)
                dispatch(requestOddSectionsAndQuestions);

            if (props.oddProductDateResponded.kind === REQUEST_STATES.NOT_REQUESTED)
                dispatch(requestOddProductDateRespondedForCurrentPlan);
        }
    };

    const renderManagerDetails = () => {
        return <div className="product__manager-button-container">
            <button className="product__manager-button"
                       onClick={() => {navigateTo(`/managers/${props.product!.managerBackstopId}`, navigate);}}>
                {props.product!.managerName}
            </button>
        </div>;
    };

    const getSelected = (tab: ProductPageTab) => props.currentTab
        ? props.currentTab === tab ? "selected" : ""
        : "";

    const getFrench = () => intl.locale === "fr-FR"
    ? "french"
        : "";

    const getKeyFromValue = (tab: ProductPageTab): string => {
        return (Object.keys(ProductPageTab) as (keyof typeof ProductPageTab)[])
            .filter((key) => (ProductPageTab[key] === tab))[0];
    };

    const tabOnClick = (tab: ProductPageTab) => {
        dispatch(setCurrentProductTab(tab));
        UserBehaviorTrackerApi.trackUserBehavior(getBrowserLocationPath() + `/${tab.toLowerCase()}`);
    };

    const renderTab = (tab: ProductPageTab) => {
        return <div id={`product__tab-${getKeyFromValue(tab).toLowerCase()}`}
                    className={`tab clickable ${getSelected(tab)} ${getFrench()}`}
        onClick={() => tabOnClick(tab)}>
            <h6><FormattedMessage
                id={`product-tab.${tab}`}
                defaultMessage={tab}
            /></h6>
        </div>;
    };

    const hasResearchAndRated = () => {
        return (props.hasClientResearchEnabled || props.hasResearchAccess)
            && product!.currentRating.value !== NOT_RATED;
    };

    const hasResearchAccess = () => {
        return props.hasClientResearchEnabled || props.hasResearchAccess;
    };

    const hasOddDetails = () => {
        return !!getSuccessData(props.oddProductQuestionResponse)?.find(
            (response) => response.productBackstopId === productBackstopId
        );
    };

    const hasOddIq = () => {
        return  props.oddIqEnabled && hasOddDetails();
    };

    const hasOdd = (): boolean => {
        const rating = product!.oppDueDiligenceRatings!.rating!;
        return !(!rating || rating === NR_RATING) || hasOddIq();
    };

    const renderTabs = () => {
        return <div className="tabs__container">
            {hasResearchAndRated() ? renderTab(ProductPageTab.IDD) : null}
            {showPerformanceAnalyticsTab()
                ? renderTab(ProductPageTab.PERFORMANCE_ANALYTICS)
                : null
            }
            {hasOdd() ? renderTab(ProductPageTab.ODD) : null}
            {hasResearchAndRated() ? renderTab(ProductPageTab.FLASH_REPORTS) : null}
        </div>;
    };

    const showPerformanceAnalyticsTab = () => {
        const performance = informProps?.performance as IInformPerformance;
        return informProps?.summary?.relativePerformance?.length
            || (performance && (performance.productCumulative.length || performance.monthlyExcessReturnValues.length));
    };

    const isInformProduct = () => {
        return product!.currentRating.ratingType === ProductRatingType.INFORM;
    };
    const renderIdd = () => {
        const MP_COLLAPSED_LENGTH = 500;
        return props.currentTab === ProductPageTab.IDD && hasResearchAndRated()
        ? isInformProduct()
            ? <InformInvestmentDueDiligence product={product!}
                                            informProduct={informProps as IInformProduct}
                                            renderErrorComponent={renderErrorComponent}
                                            shouldRenderESG={
                                            shouldRenderESG(props.currentPlan.name, props.currentPlan.countryId)
                                            }
                />
            : <InvestmentDueDiligence product={props.product!}
                                      userType={props.userType}
                                      mpCollapsedLength={MP_COLLAPSED_LENGTH}
                                      shouldRenderESG={
                                        shouldRenderESG(props.currentPlan.name, props.currentPlan.countryId)
                                      }

        />
            : null;
    };

    const renderOdd = () => {
        return props.currentTab === ProductPageTab.ODD
            ? <OperationalDueDiligence
                product={product!}
                oddIqEnabled={props.oddIqEnabled}
                oddProductQuestionResponse={getSuccessData(props.oddProductQuestionResponse)!}
                oddSectionsQuestions={getSuccessData(props.oddSectionsQuestions)!}
                oddProductDateResponded={getSuccessData(props.oddProductDateResponded)!}
            />
            : null;
    };

    const renderFlashReports = () => {
        return props.currentTab === ProductPageTab.FLASH_REPORTS
            ? <ProductFlashReports productBackstopId={productBackstopId}/>
            : null;
    };

    const renderPerformanceAnalytics = () => {
        return props.currentTab === ProductPageTab.PERFORMANCE_ANALYTICS && informProps
            ? <ProductPerformanceAnalytics
                informProduct={informProps}/>
            : null;
    };

    const renderAddOrAddedToPortfolio = () => {
        return props.editingPlanPortfolio
        ? props.portfolioProductSummaries?.has(productBackstopId)
            ? renderAddedToPortfolioText()
                : renderAddToPortfolioButton()
        : null;
    };


    const renderAddToPortfolioButton = () => {
        return <RaisedButton
            className="add-to-portfolio-button"
            style={defaultButtonStyle}
            primary={true}
            onClick={
                () => props.actions.addProductToPlanPortfolio(props.product!)
            }>
            Add to Portfolio
        </RaisedButton>;
    };

    const renderAddedToPortfolioText = () => {
        return <div className="added-to-portfolio-text">ADDED TO PORTFOLIO</div>;
    };

    const setCurrentTab = () => {
        if(props.product) {
            let tab = ProductPageTab.IDD;
            if (queryStringTab === "ODD" && hasOdd()){
                tab = ProductPageTab.ODD;
            }
            else if(!hasResearchAndRated() && hasOdd()){
                tab = ProductPageTab.ODD;
            }
            dispatch(setCurrentProductTab(tab));
            UserBehaviorTrackerApi.trackUserBehavior(getBrowserLocationPath() + `/${tab.toLowerCase()}`);
        }
    };

    useEffect(() => {
        if (props.portfolioProductSummaries || props.editingPlanPortfolio) {
            requestProductDetails();
            return;
        }

        if (props.portfolioProductSummariesState.kind === REQUEST_STATES.NOT_REQUESTED) {
            dispatch(getPortfolioProductSummaries);
        }
    }, [
        backstopIdParam,
        dispatch,
        props.editingPlanPortfolio,
        props.portfolioProductSummaries,
        props.portfolioProductSummariesState.kind,
    ]);

    const navigationType = useNavigationType();
    useEffect(() => {
        if (notPopNavigation(navigationType) || !props.currentTab) {
            setCurrentTab();
        }
        if (props.product) {
            if(isInformProduct()) {
                InFormReportingApi.fetchInformProduct(productBackstopId).then((response: any) => {
                    setInformProps(response);
                    setInformLoading(false);
                }).catch(() => {
                    setRenderErrorComponent(true);
                    setInformLoading(false);
                });
            } else {
                InFormReportingApi.fetchInformDetailsForFundamentalProduct(productBackstopId)
                    .then((response: any) => {
                        setInformProps(response);
                        setInformLoading(false);
                    }).catch(() => {
                    setInformLoading(false);
                });
            }
        }
    }, [props.product]);

    useEffect(() => {
        requestOddData();
    }, []);

    if (props.portfolioProductSummaries && !isProductAccessible()) {
        return <ErrorComponent/>;
    }
    if (!product || props.productLoading || props.productLoading === undefined || informLoading) {
        return <LoadingSpinner/>;
    }
    if (!hasResearchAndRated() && !hasOdd()) {
        return <ErrorComponent/>;
    }

    return <div className="main-content new-common-styles">
            <div className="product__content">
                <div className="product__title-container">
                    <h1 className={`product__title ${props.oddIqEnabled ? "product__title-oddIq" : ""}`}>
                        {product!.name}
                    </h1>
                    {hasResearchAccess() ? renderManagerDetails() : null}
                </div>
                <ProductResearcher product={product!}/>
                <div className="product__add-to-portfolio-container">
                    {renderAddOrAddedToPortfolio()}
                </div>
                {renderTabs()}
                {renderIdd()}
                {renderPerformanceAnalytics()}
                {renderOdd()}
                {renderFlashReports()}
            </div>
        </div>;
};

export const shouldRenderESG = (planName: string, countryId: number) => {
    return planName === EMPOWER_RESULTS_PLAN || countryId !== Country.USA.valueOf();
};

export const mapStateToProps = (state: IApplicationRootState): IProductPagePropsFromStore => {
    return {
        product: state.productPageState!.product,
        productLoading: state.productPageState!.productLoading,
        productError: state.productPageState!.productError,
        editingPlanPortfolio: isEditingPlanPortfolio(state),
        currentPlan: currentPlan(state),
        userType: userType(state),
        planCountryName: planCountryName(state),
        portfolioProductSummaries: getSuccessData(portfolioProductSummariesSelector(state))!,
        portfolioProductSummariesState: portfolioProductSummariesSelector(state)!,
        oddProductQuestionResponse: oddResponsesByBackstopSelector(state),
        oddIqEnabled: oddIqEnabled(state),
        hasClientResearchEnabled: hasClientResearchEnabled(state),
        hasResearchAccess: hasResearchAccess(state),
        oddSectionsQuestions: operationalDueDiligenceSectionsQuestionsSelector(state),
        oddProductDateResponded: oddProductDateRespondedSelector(state),
        currentTab: currentProductPageTab(state),
    };
};

export const mapDispatchToProps = (dispatch: Dispatch<AnyAction>): IProductPropsFromActions => {
    return {
        actions: bindActionCreators({
            ...productActions,
        }, dispatch),
    };
};

const connectedProductPage =
    connect<IProductPagePropsFromStore, IProductPropsFromActions, {}, IApplicationRootState>(
        mapStateToProps,
        mapDispatchToProps,
    )(ProductPage);

export default multipleApiRequesterWrapper(
    connectedProductPage,
    [
        shareClassRequestPair,
    ],
);
